 const wowApp = require('angular').module('wowApp.shop');
const _ = require('lodash');

function transformToRoutePlaceholderMap(results) {
    return _.chain(results).keys().reduce((result, key) => {
        const { route, placeholder } = results[key];
        result[route] = placeholder;
        return result;
    }, {}).value();
}

const PageRouteToPlaceHolderMap = transformToRoutePlaceholderMap(require('./page-to-placeholder-mapper'));

wowApp.factory('RRConfig', ['$window', require('./rr-config')]);
wowApp.factory('RRInstance', ['$window', require('./rr-instance-maker')]);

wowApp.service('RRPubSub', [require('./rr-pub-sub')]);
wowApp.service('RREventSend', ['$window', require('./rr-event-send')]);
wowApp.service('RRContextFactory', ['RRConfig', 'RRInstance', 'CurrentUserService', 'RREventSend', '$window', require('./rr-context-factory')]);
wowApp.service('RREventFactory', ['RRContextFactory', 'RRInstance', 'Restangular', require('./rr-event-factory')]);
wowApp.service('RRStateChangedService', ['RREventFactory', 'RRPubSub', require('./rr-state-changed-service')]);
wowApp.service('RRPlacementNotification', ['Restangular', 'DecorateAdditionalDetails', '$window', '$log', 'SearchService', '$location', require('./rr-placement-notification')]);
wowApp.directive('richerRelevanceCarousel', [require('./rr-carousel-directive')]);

function buildRRCache(placeholders) {
    const cache = {};
    _.forEach(placeholders, (holder) => {
        cache[holder] = {
            title: '',
            products: [],
            refreshedOn: undefined,
            previousRefresh: undefined
        };
    });
    return cache;
}

wowApp.constant('PageRouteToPlaceHolderMap', PageRouteToPlaceHolderMap);
wowApp.constant('rrPlaceHolderCache', buildRRCache(_.values(PageRouteToPlaceHolderMap)));

/*eslint-disable */
wowApp.run(RRPlacementNotification => {}); // required to start listening for RR events;
/*eslint-enable */



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/index.js
 **/